import clsx from 'clsx';
import React from 'react';

type StatusCategory =
  | 'DRAFT'
  | 'NEW'
  | 'RESUBMIT'
  | 'IP'
  | 'LOCKED'
  | 'CMPLT'
  | 'CLOSED'
  | 'ERROR'
  | string;

interface StatusPillProps {
  status: string;
  category?: StatusCategory;
  className?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, category, className }) => {
  // D: Draft; I: Initial; T: Transitory; F: Final
  const categoryKinds: Record<string, 'D' | 'I' | 'T' | 'F'> = {
    DRAFT: 'D',
    NEW: 'I',
    RESUBMIT: 'I',
    IP: 'T',
    LOCKED: 'T',
    CMPLT: 'F',
    CLOSED: 'F',
    ERROR: 'F',
  };

  const kindStyles: Record<'D' | 'I' | 'T', string> = {
    D: 'tw:bg-yellow-100 tw:text-yellow-800 tw:border-yellow-500/20 tw:dark:bg-yellow-800/25 tw:dark:text-yellow-200 tw:dark:border-yellow-400/40',
    I: 'tw:bg-blue-100 tw:text-blue-800 tw:border-blue-500/20 tw:dark:bg-blue-800/25 tw:dark:text-blue-200 tw:dark:border-blue-400/40',
    T: 'tw:bg-orange-100 tw:text-orange-800 tw:border-orange-500/20 tw:dark:bg-orange-800/25 tw:dark:text-orange-200 tw:dark:border-orange-400/40',
  };

  // Categories with a category_kind of "F" (final) need their own styles
  const finalStyles: Record<string, string> = {
    CMPLT:
      'tw:bg-green-100 tw:text-green-800 tw:border-green-500/20 tw:dark:bg-green-800/25 tw:dark:text-green-200 tw:dark:border-green-400/40',
    CLOSED:
      'tw:bg-zinc-100 tw:text-zinc-800 tw:border-zinc-300 tw:dark:bg-zinc-600 tw:dark:text-zinc-200 tw:dark:border-zinc-400',
    ERROR:
      'tw:bg-red-100 tw:text-red-800 tw:border-red-300 tw:dark:bg-red-600 tw:dark:text-red-200 tw:dark:border-red-400',
  };

  const categoryKey = category?.toUpperCase() || '';
  const kind = categoryKinds[categoryKey];

  const statusClass =
    (kind === 'F' && finalStyles[categoryKey]) ||
    (kind && kindStyles[kind]) ||
    'tw:bg-zinc-100 tw:text-zinc-800 tw:border-zinc-300 tw:dark:bg-zinc-600 tw:dark:text-zinc-200 tw:dark:border-zinc-400';

  return (
    <span
      className={clsx(
        'tw:text-xs tw:px-2 tw:py-1 tw:rounded-full tw:border tw:text-center',
        statusClass,
        className
      )}
    >
      {status}
    </span>
  );
};

export default StatusPill;
